export const ROUTE_ENDPOINTS = {
  LOGIN: "/login",
  HOME_: "/home",
  HOME: "/home/*",
  HOME_USERS: "/home/users",
  HOME_STATS: "/home/stats",
  HOME_CATEGORIES: "/home/categories",
  HOME_QUESTIONS: "/home/questions",
  USERS: "/users",
  LOGS: "/logs",
  GAMES: "/games",
  STATS: "/stats",
  CATEGORIES: "/categories",
  QUESTIONS: "/questions",
};

export const ROUTE_NEW = "new";
